import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-todays-open-unresolved-tickets',
  templateUrl: './todays-open-unresolved-tickets.component.html',
  styleUrls: ['./todays-open-unresolved-tickets.component.css']
})
export class TodaysOpenUnresolvedTicketsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.TodaysToBeResolvedTicket();
  }

  TodaysToBeResolvedTicket = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.todaysToBeResolvedTicket()
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/todays-open-unresolved-tickets/todays-open-unresolved-tickets.component.ts